import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ProductCustomerDetails } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductCustomerService extends TmsWebBaseEditCreateService<
  ProductCustomerDetails,
  ProductCustomerDetails
> {
  constructor() {
    super('ProductCustomer', $localize`Customer Products`);
  }

  getForCustomer(id: string): Observable<ProductCustomerDetails[]> {
    return this.httpService.get<ProductCustomerDetails[]>(`${this.apiUrl}/CustomerProducts/${id}`);
  }
}
